export default "__VITE_ASSET__CSY5AM5y__"